import React, { Component } from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import FontIcon from 'material-ui/FontIcon';
import Collapsible from 'react-collapsible';
import _ from 'lodash';

import { updateQuiz } from '../actions/index';

import { HELPERS } from '../config/constants';

import '../styles/Question.css';

class QuestionOption extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.onOptionClick = this.onOptionClick.bind(this);
    this.color = this.color.bind(this);
    this.char = String.fromCharCode(65 + props.index);

    this.onKeyDown = _.debounce(this.onKeyDown, 75, {
      leading: true,
      trailing: false
    }).bind(this);
  }

  componentWillMount() {
    document.addEventListener('keydown', this.onKeyDown, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown, false);
  }

  componentWillReceiveProps(next) {
    const { answered } = this.props;

    !answered && next.answered
      ? document.removeEventListener('keydown', this.onKeyDown, false)
      : null;
  }

  onKeyDown(e) {
    switch (e.key.toUpperCase()) {
      case `${this.char}`: {
        this.onOptionClick();
        break;
      }
      default:
    }
  }

  onOptionClick() {
    const {
      answered,
      index,
      currentQuestionIndex,
      explanationVisible,
      updateQuiz
    } = this.props;

    !answered
      ? updateQuiz(
          HELPERS.UPDATE_OBJECT(
            { selectedOptionIndex: index },
            currentQuestionIndex
          )
        )
      : updateQuiz(
          HELPERS.UPDATE_OBJECT(
            { explanationVisible: !explanationVisible },
            currentQuestionIndex,
            index
          )
        );
  }

  // TODO clean this mess
  color(isText = false) {
    const {
      answered,
      selected,
      testMode,
      isCorrectOption,
      finished
    } = this.props;

    return selected && (answered === false || (testMode && !finished))
      ? '#464646'
      : (!testMode || finished) && answered && isCorrectOption
        ? '#94C057'
        : (!testMode || finished) && selected
          ? '#FF7362'
          : isText ? '#5C5C5C' : '#444';
  }

  render() {
    //Maintain explanationVisible for easy change back to just dispalying answer and selected explanation

    const {
      answered,
      index,
      selected,
      testMode,
      isCorrectOption,
      attempted,
      body,
      explanation,
      viewOnly,
      finished
    } = this.props;
    const selectedCount = this.props.optionStats
      ? this.props.optionStats[index]
      : 0;

    return (
      <div
        className={`question-option${
          answered && (!testMode || finished)
            ? isCorrectOption
              ? ' answered correct'
              : selected ? ' answered incorrect' : ' answered'
            : ''
        }`}
        onClick={this.onOptionClick}
      >
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <FontIcon
            className="material-icons option-select-icon"
            color={this.color()}
          >
            {(selected && (testMode || (!testMode && !answered))) ||
            ((!testMode || finished) && answered && isCorrectOption)
              ? 'check_circle'
              : selected ? 'cancel' : 'radio_button_unchecked'}
          </FontIcon>
        </div>
        <div className="option-div">
          {answered && !testMode ? (
            <div
              className="imported-p-parent"
              style={{ display: 'flex', justifyContent: 'space-between' }}
            >
              <div
                style={{ color: this.color(true) }}
                dangerouslySetInnerHTML={{
                  __html: unescape(this.char + '. ' + body)
                }}
              />
            </div>
          ) : (
            <div className="imported-p-parent" style={{ display: 'flex' }}>
              <div
                style={{ color: this.color(true) }}
                dangerouslySetInnerHTML={{
                  __html: unescape(this.char + '. ' + body)
                }}
              />
            </div>
          )}
          {explanation && (!testMode || finished) ? (
            <Collapsible
              style={!answered ? { display: 'none' } : {}}
              open={answered}
            >
              <div
                className="explanation-wrapper"
                dangerouslySetInnerHTML={{ __html: unescape(explanation) }}
              />
            </Collapsible>
          ) : null}
          {!viewOnly && answered && (!testMode || finished) ? (
            <div className="percent-chose">
              {isNaN(
                Math.round(
                  selected
                    ? (selectedCount + 1) / (attempted + 1) * 100
                    : selectedCount / (attempted + 1) * 100
                )
              )
                ? '--'
                : Math.round(
                    selected
                      ? (selectedCount + 1) / (attempted + 1) * 100
                      : selectedCount / (attempted + 1) * 100
                  )}% choose this answer
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, props) {
  const question = state.quiz.questions[state.quiz.currentQuestionIndex];
  const option = question.options[props.index];

  return {
    selected: question.selectedOptionIndex === props.index,
    answered: question.answered,
    explanationVisible: option.explanationVisible || state.quiz.viewOnly,
    testMode: state.quiz.mode === 1,
    images: option.images,
    attempted: state.optionStats ? state.optionStats.total : 0,
    body: option.body,
    explanation: option.explanation,
    currentQuestionIndex: state.quiz.currentQuestionIndex,
    isCorrectOption: option.correctOption,
    viewOnly: state.quiz.viewOnly,
    optionStats: state.optionStats,
    currentQuestionId: question.id,
    finished:
      state.quiz.questions.reduce(
        (total, question) => total + (question.answered ? 1 : 0),
        0
      ) === state.quiz.questions.length
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ updateQuiz }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(QuestionOption);

// QuestionOption.propTypes = {
//   option: React.PropTypes.shape({
//     id: React.PropTypes.string.isRequired,
//     correctOption: React.PropTypes.bool.isRequired,
//     body: React.PropTypes.string.isRequired,
//     explanation: React.PropTypes.string.isRequired,
//     images: React.PropTypes.arrayOf(
//       React.PropTypes.shape({
//         url: React.PropTypes.string.isRequired,
//       }),
//     ),
//   }).isRequired,
//   id: React.PropTypes.string.isRequired,
//   mode: React.PropTypes.string.isRequired,
//   selectedId: React.PropTypes.string.isRequired,
//   onOptionClick: React.PropTypes.func.isRequired,
// };



// WEBPACK FOOTER //
// ./src/containers/QuestionOption.js